<template>
    <section id="latest-news01">
        <div class="title-bg">
            <h2 class="new-title p-0 line-height">{{ $t('home.latest-news.title') }}</h2>
        </div>
        <div class="news-spacing d-flex align-items-center justify-content-center">
            <div class="new-container">
                <div class="d-flex flex-wrap justify"  v-if="news.length">
                    <template v-for="(item, index) in news">
                        <div v-if="index < 2" class="news-img position-relative mb-40 spacing-right" :key="index + Math.random()">
                            <router-link :to="`new/${item.id}`" >
                                <img  :src="`${item.image}`" :alt="`${item.title[$i18n.locale]}`" style="height: 100%; width: 100%;">
                            </router-link>
                            <router-link :to="`new/${item.id}`" class="text-white view-more d-flex align-items-center" >Մանրամասն
                                <img src="assets/landing/images/Vector.svg" >
                            </router-link>
                        </div>
                    </template>
                    <div>
                        <VtbBanner />
                    </div>
                    <template v-for="(item, index) in news" >
                        <div v-if="index >= 2" class="news-img position-relative mb-40 spacing-right" :key="index + Math.random()">
                            <router-link :to="`new/${item.id}`" >
                                <img  :src="`${item.image}`" :alt="`${item.title[$i18n.locale]}`" style="height: 100%; width: 100%;">
                            </router-link>
                            <router-link :to="`new/${item.id}`" class="text-white view-more d-flex align-items-center" >Մանրամասն
                                <img src="assets/landing/images/Vector.svg" >
                            </router-link>
                        </div>
                    </template>   
                    <div class="news-img mob-spacing-right hide-block" style="height: 0;"></div> 
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import WOW from 'wowjs';
import VtbBanner from '@/components/dashboard/banner'

export default {
    components: { VtbBanner },
    mounted() {
        new WOW.WOW({
            live: false
        }).init();
        this.$store.dispatch('news/get')
    },
    computed: {
        news() {
            return this.$store.getters['news/event']
        }
    },
    data() {
      return {
      }
    },
    name: 'News',
  }
</script>
<style scoped>
    .mb-40{
        margin-bottom: 40px;
    }
    .news-block{
        width: calc(100% - 405px);
    }
    .iframe-block{
        width: 405px;
    }
    .new-title{
        font-size: 47px !important;
        text-align: center !important;
        font-weight: 500 !important;
        color: #0F0E0E !important;
        padding: 21px 0;
        text-transform: uppercase;
        word-spacing: 12px;
        letter-spacing: -1px;
    }
    .title-bg{
        background-color: rgba(30, 123, 184, 0.15);
    }
    .line-height{
        line-height: 80px;
    }
    .view-more{
        background-color: #43B4B2;
        border-radius: 50px;
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 12px 14px;
        cursor: pointer;
        z-index: 111;
    }
    .view-more img{
        margin-left: 2px;
    }
    .new-container{
        width: 100%;
        padding: 0 8%;
    }
    .news-spacing{
        margin: 40px 0 0;
    }
    .bg-image{
        background-image: url('/assets/landing/images/bg-image.jpg');
        background-size: cover;
        height: 612px;
        background-position: center;
        margin-left: 5%;
        margin-right: 5%;
        background-attachment: fixed;
    }
    .new-card{
        width: 404px;
        height: 304px;
        border: 0;
    }  
    .news-img{
        width: 405px;
        height: 305px;
    }
    .spacing-right{
        margin-right: 30px;
    }
    .justify{
        justify-content: space-between;
    }
    @media only screen and (max-width: 1518px) {
        .justify{
            justify-content: center;
        }
        .mob-spacing-right{
            margin-right: 15px;
            margin-left: 15px;
        }
        .spacing-right{
            margin-right: 15px;
            margin-left: 15px;
        }
    }
    @media only screen and (max-width: 1210px) {
        .mr_4{
            margin-right: 1.5rem !important;
        }
    }
    @media only screen and (max-width: 1100px) {
        .new-title{
            font-size: 30px !important;
        }
        .bg-image{
            height: 380px;
        }
    }
    @media only screen and (max-width: 1170px) {
        .iframe-block{
            display: none;
        }
        .hide-block{
            display: none;
        }
    }
    @media only screen and (max-width: 1050px) {
        .news-img{
            width: 322px;
            height: 322px;
        }
    }
    @media only screen and (max-width: 810px) {
        .news-img{
            width: 390px;
            height: 390px;
        }
    }
    @media only screen and (max-width: 650px) {
        .new-title{
            font-size: 22px !important;
        }
    }
    @media only screen and (max-width: 500px) {
        .news-img{
            width: 300px;
            height: 300px;
        }
        .new-title{
            font-size: 22px !important;
            padding: 10px  0 !important;
        }
    }
    @media only screen and (max-width: 400px) {
        .news-img{
            width: 260px;
            height: 260px;
        }
    }
</style>
